import {
    buildDailyExcelRows,
    buildMonthlyExcelPayload,
    writeDailyExcelFile,
    writeMonthlyExcelFile,
} from "./attendanceExportUtils";
import { getMonthlyAttendanceRate } from "./attendanceViewDataUtils";

export default function useAttendanceDownloadAction({
    XLSX,
    activeTab,
    currentDate,
    currentMonth,
    dailyAttendance,
    filteredStudents,
    monthlyData,
    onYearlyUnsupportedDownload,
    sundaysInMonth,
}) {
    const handleDownloadExcel = () => {
        if (activeTab === "daily") {
            const rows = buildDailyExcelRows(filteredStudents, dailyAttendance);
            writeDailyExcelFile({ XLSX, rows, currentDate });
        } else if (activeTab === "monthly") {
            const { header, rows } = buildMonthlyExcelPayload({
                filteredStudents,
                monthlyData,
                sundaysInMonth,
                getMonthlyAttendanceRateFn: getMonthlyAttendanceRate,
            });
            writeMonthlyExcelFile({ XLSX, header, rows, sundaysInMonth, currentMonth });
        } else {
            onYearlyUnsupportedDownload?.();
        }
    };

    return { handleDownloadExcel };
}
